import ApplicationCard from './ApplicationCard.component';

export default ApplicationCard;